import { createSlice } from '@reduxjs/toolkit';

import { loadWidgetThunkAction } from '../../redux/load-widget-thunk';
import { getSlugFromURL } from '../../utils/get-slug';
import { EventType, State } from './event-detail-types';

export const initialState: State = {
  event: {
    name: '',
    externalId: '',
    url: '',
    startTime: '',
    endTime: '',
    doorsOpenTime: '',
    doorsCloseTime: '',
    totalUsersRegistered: 0,
    totalUsersWaitlisted: 0,
    currency: 'usd',
    organizationMerchantId: '',
    postEventEnabled: false,
    postEventTimeEnd: null,
    fullUrl: '',
    linkedinCompanyUrlEnabled: false,
    linkedinCompanyUrl: '',
    linkedinCommunityBuilderEnabled: false,
    linkedinEventId: '',
    eventType: EventType.Hidden,
    isLite: false,
    published: false,
  },
  images: {
    medium: '',
    large: '',
  },
  settings: {
    authEnabled: false,
    maxTicketsPerOrder: 1,
    allowedFeatures: {},
    maxRegistrations: 0,
    registrationCloseMessage: '',
    feeSplit: '',
    maxWaitlist: 0,
    waitlistEnabled: false,
    successfulWaitlistMessage: '',
    unsuccessfulWaitlistMessage: '',
    registrationCloseTime: '',
    waitlistCloseTime: '',
    organizationId: null,
    organizationExternalId: null,
  },
  tickets: [],
  forms: [],
  stripeDirect: false,
  googleAnalyticsCode: '',
  widgetId: '',
  widgetSource: 'unknown',
  single_ticket_without_segments: false,
  isExternalWidget: false,
  trackingIntegrations: [],
  showEventSeries: false,
};

const eventDetailSlice = createSlice({
  name: 'eventDetails',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(loadWidgetThunkAction.fulfilled, (state, action) => {
      const {
        event,
        images,
        settings,
        tickets,
        forms,
        googleAnalyticsCode,
        widgetId,
        widgetSource,
        stripeDirect,
        single_ticket_without_segments,
        trackingIntegrations,
      } = action.payload.eventDetails;

      state.isExternalWidget = action.payload.isExternalWidget;
      state.widgetId = widgetId;
      state.widgetSource = widgetSource;
      state.event = event;
      state.event.url = getSlugFromURL(event.url);
      state.images = images;
      state.settings = settings;
      state.tickets = tickets;
      state.forms = forms;
      state.stripeDirect = stripeDirect;
      state.googleAnalyticsCode = googleAnalyticsCode;
      state.single_ticket_without_segments = single_ticket_without_segments;
      state.trackingIntegrations = trackingIntegrations;
      state.showEventSeries =
        action.payload.features?.show_event_series || false;
    });
  },
});

// eslint-disable-next-line import/no-default-export
export default eventDetailSlice.reducer;
